import React from "react";
import CheckIcon from "../../../assets/svg/check-icon";
import { OptionsListProps } from "../types";
import PulseLoader from "../../Loader/PulseLoader";

const OptionsList: React.FC<OptionsListProps> = ({
  filteredAndSortedOptions,
  value,
  focusedIndex,
  dropdownId,
  optionClassName,
  searchQuery,
  onOptionSelect,
  onFocusedIndexChange,
  isSearching = false,
  loadingText = "",
  noResultsText = "No results found",
  enableApiSearch = false,
  optionsListClassName = "",
}) => {
  if (isSearching) {
    return (
      <div className="px-3 py-3 flex items-center text-center justify-center gap-2 text-sm text-gray-placeholder dark:text-gray-placeholder-dk">
        <PulseLoader size={4} />
        {loadingText && <span>{loadingText}</span>}
      </div>
    );
  }

  if (filteredAndSortedOptions.length === 0) {
    const message =
      enableApiSearch && searchQuery.trim()
        ? noResultsText
        : "No options available";

    return (
      <div className="px-3 py-3 flex items-center text-center justify-center gap-2 text-sm text-gray-placeholder dark:text-gray-placeholder-dk">
        {message}
      </div>
    );
  }

  return (
    <div className={`py-1 ${optionsListClassName}`}>
      {filteredAndSortedOptions.map((option, index) => {
        const isSelected = option.value === value;
        const isFocused = index === focusedIndex;
        const isDisabled = option.disabled || false;

        return (
          <div
            key={
              option.id
                ? `${option.id}-${index}`
                : `${dropdownId}-option-${index}`
            }
            id={`${dropdownId}-option-${index}`}
            role="option"
            aria-selected={isSelected}
            aria-disabled={isDisabled}
            tabIndex={-1}
            className={`
              flex items-center justify-between cursor-pointer border-b border-border-gray dark:border-border-gray-dk 
              last:border-b-0 transition-colors px-[14px] py-[10px] min-w-0
              ${
                isDisabled
                  ? "opacity-50 "
                  : isSelected
                    ? "bg-card-highlight dark:bg-card-highlight-dk font-medium"
                    : isFocused
                      ? "bg-hover-effect dark:bg-hover-effect-dk"
                      : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
              }
              ${optionClassName}
            `}
            onClick={() => onOptionSelect(option)}
            onMouseEnter={() => !isDisabled && onFocusedIndexChange(index)}
          >
            <div className="overflow-hidden flex-1 min-w-0 pr-2 select-none">
              {option.content}
            </div>

            {isSelected && (
              <CheckIcon className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OptionsList;
